// Presentation only. A seal is shown only for the existing verified issued response.
const {validateMemberBoard}=require('./memberBoardContract');
function nextPickSeal(data,now=Date.now(),stale=false){
 try{
  validateMemberBoard(data,{view:'next',pro:data?.access==='pro'});
  if(!data.issued||!Number.isFinite(now))return null;
  const times=data.rows.map(r=>Date.parse(r.lockedAt));
  if(times.some(t=>!Number.isFinite(t)||t>now||t!==times[0]))return null;
  const today=new Intl.DateTimeFormat('en-CA',{timeZone:'America/New_York',year:'numeric',month:'2-digit',day:'2-digit'}).format(now);
  const label=data.target.session==='midday'?'Midday picks':!stale&&data.target.date===today?"Tonight's picks":'Evening picks';
  const time=new Intl.DateTimeFormat('en-US',{timeZone:'America/New_York',hour:'numeric',minute:'2-digit',second:'2-digit'}).format(times[0])+' Eastern';
  return {label,time,lockedAt:data.rows[0].lockedAt};
 }catch{return null;}
}
module.exports={nextPickSeal};
